import React, { ReactElement } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'utils/localization';
import AppLayout from 'components/layouts/AppLayout';

const TermsAndConditions = (): ReactElement => {
    const { t } = useTranslation();
    return (
        <AppLayout
            title={t('pages.termsAndConditions')}
            pageTitle={{
                primaryBoldText: t('pages.termsAndConditions'),
                isDark: true,
            }}
            showLangMenu={true}
        >
            <div style={{ maxWidth: '60rem' }}>
                <ReactMarkdown>
                    {t('TermsAndConditions.text', {
                        link: 'https://www.fotbal.cz/urednideska/uredni-deska-predpisy?category=1',
                    })}
                </ReactMarkdown>
            </div>
        </AppLayout>
    );
};

export default TermsAndConditions;
